document.addEventListener('DOMContentLoaded', function() {
    setTimeout(() => {
        // Handle URL hash on page load with delay
        if (window.location.hash) {
            const hash = window.location.hash.substring(1);
            const targetElement = document.getElementById(hash);
            console.log(hash);
            console.log(targetElement);
            console.log(targetElement.getBoundingClientRect().top);
            if (targetElement) {
                
                const offset = 100;
                const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - offset;
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            }
        }
    }, 100);
});